import { render, staticRenderFns } from "./ActionAI.vue?vue&type=template&id=72464595"
import script from "./ActionAI.vue?vue&type=script&lang=js"
export * from "./ActionAI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports